import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { IFeedbackItem } from "../../../setup/api/services/feedbackAndReview/models";
import { RatingStarScore } from "../../rating/ratingStarScore";
import styles from "./styles.module.scss";

interface Props {
  isShowModal?: boolean;
  item: IFeedbackItem;
}

const ListFeedbackItem = (props: Props) => {
  const { item } = props;
  const { t } = useTranslation();

  const renderAvaterWithText = () => (
    <div className={styles["verified_container"]}>
      <div className={styles.check_mark}>
        <img alt="close" src={"/assets/images/svg/checkMark.svg"} />
      </div>
      <p className={classNames(styles.hint, styles.g700)}>
        {t("lbl_verified_text")}
      </p>
    </div>
  );

  return (
    <div
      className={classNames(
        styles["container"],
        styles["card"],
        styles["mb8"]
      )}>
      <RatingStarScore ratingScore={item?.ratingScore} />
      <div className={styles["container__comments"]}>
        <span className={classNames(styles["hint"], styles["g700"])}>
          {item?.comment}
        </span>
        {item?.provider?.nationalIdVerified && <>{renderAvaterWithText()}</>}
      </div>
    </div>
  );
};

export default ListFeedbackItem;
